export const BASE_PATH = "/help-support";
const articleSlug = (articleTitle: string): string =>
  articleTitle
    ? articleTitle
        .toLowerCase()
        .replace(/[^A-Za-z0-9]+/g, "-")
        .replace(/-$/, "")
    : "";

export const routes = {
  home: () => BASE_PATH,
  category: (category: string): string => `${BASE_PATH}/${category}`,
  subCategory: (category: string, subCategory: string): string =>
    `${BASE_PATH}/${category}/${subCategory}`,
  article: (
    category: string,
    subCategory: string,
    articleId: string,
    articleName: string
  ): string =>
    `${BASE_PATH}/${category}/${subCategory}/${articleSlug(
      articleName
    )}/${articleId}`,
};
